export default {
  existing_documents: {
    description: 'Já carregou os seguintes documentos. Selecione um e prima enviar, ou carregue um novo documento.',
    sides: {
      front: 'Frente',
      back: 'Verso',
    },
    created_at: 'Carregado: {{date}}',
    expires_at: 'Expira: {{date}}',
  },
  document_types: {
    owner_document: 'Documento de identidade do titular',
    business_document: 'Documento empresarial',
  },
  form: {
    document_type: {
      label: 'Documento de prova de identidade',
      placeholder: 'Selecionar tipo de documento',
      options: {
        passport: 'Passaporte',
        driver_license: 'Carta de condução',
        id_card: 'Cartão de cidadão',
        residence_permit: 'Autorização de residência',
      },
    },
    front: {
      label: 'Frente do documento',
    },
    back: {
      label: 'Verso do documento (opcional para alguns documentos)',
    },
    expires_at: {
      label: 'Data de validade do documento',
      placeholder: 'Selecionar data de validade',
    },
  },
  buttons: {
    select_file: 'Selecionar ficheiro',
    next: 'Seguinte',
    back: 'Verso',
    send: 'Enviar',
    upload_new: 'Carregar novo documento',
    use_existing: 'Usar um documento já carregado',
  },
};
